module.exports = __webpack_public_path__ + "img/SMT_18_Mr_Goh_Dan_Yang.8c218bcf.jpg";